// extracted by mini-css-extract-plugin
export var container = "area-breadcrumbs-row-module--container--2wTXg";
export var breadcrumbs = "area-breadcrumbs-row-module--breadcrumbs--ANtdB";
export var link = "area-breadcrumbs-row-module--link--qLFrM";
export var rightIcon = "area-breadcrumbs-row-module--rightIcon--2UtFi";
export var areaSelectionButton = "area-breadcrumbs-row-module--areaSelectionButton--3CLjL";